import Vue from 'vue'
import { db, fb, au } from '../plugins/firebase'
import { momento } from '../plugins/moment'
import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    promociones: [],
    libros: []
  },
  mutations: {
    setPromos (state, p) {
      state.promociones = p
    },
    setLibros (state, p) {
      state.libros = p
    },
    remover (state, p) {
      let uno = state.promociones.findIndex(sel => sel.id === p.id)
      state.promociones.splice(uno, 1)
      let dos = state.libros.findIndex(sel => sel.id === p.libro)
      state.libros.splice(dos, 1)
    } 
  },
  actions: {
    realizar (ctx) {
      return new Promise((resolve, reject) => {
        let tok = ''
        au.currentUser.getIdToken(/* forceRefresh */ true)
        .then(token => {
          tok = token
          return db.ref('promocionando').set({enviando: true})
        })
        .then(() => {
          let url = 'promocion'
          return Vue.prototype.$axios.post(url, {user: tok})
        })
        .then(() => {
          return ctx.dispatch('cargar')
        })
        .then(() => {
          return resolve()
        })
        .catch(e => {
          console.error(e)
          reject(e)
        })
      })
    },
    add (ctx, p) {
      return new Promise ((resolve, reject) => {
        existe(p)
        .then(empty => {
          if (empty) {
            anadir(p)
            .then(() => {
              resolve(true)
            })
          } else {
            resolve(false)
          }
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    remover (ctx, p) {
      return new Promise ((resolve, reject) => {
        let libro = ctx.state.promociones.find(sel => sel.libro === p.id)
        fb.collection('promociones').doc(libro.id).delete()
        .then(() => {
          ctx.commit('remover', libro)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    cargar (ctx) {
      return new Promise ((resolve, reject) => {
        fb.collection('promociones').get()
        .then(results => {
          let all = []
          results.forEach(doc => {
            let item = doc.data()
            item.id = doc.id
            all.push(item)
          })
          ctx.commit('setPromos', all)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    cargaFull (ctx) {
      return new Promise ((resolve, reject) => {
        ctx.dispatch('cargar')
        .then(() => {
          return buscarLibros(ctx.state.promociones)
        })
        .then(libros => {
          ctx.commit('setLibros', libros)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    libros (state) {
      return state.libros.sort((a, b) => {
        const aL = limpiar(a.titulo)
        const bL = limpiar(b.titulo)
        if (aL < bL)
          return -1 
        if (aL > bL)
          return 1
        return 0
      })
    }
  }
}

function existe (id) {
  return new Promise ((resolve, reject) => {
    fb.collection('promociones').where('libro', '==', id).get()
    .then(results => {
      resolve(results.empty)
    })
    .catch(e => {
      console.error(e)
      reject()
    })
  })
}

function anadir (id) {
  return new Promise ((resolve, reject) => {
    fb.collection('promociones').add({
      libro: id,
      timestamp: momento().format()
    })
    .then(() => {
      resolve()
    })
    .catch(e => {
      console.error(e)
      reject()
    })
  })
}

function buscarLibros (libros) {
  return new Promise ((resolve, reject) => {
    let promesas = []
    let all = []
    libros.forEach(libro => {
      let pr = fb.collection('libros').doc(libro.libro).get()
      promesas.push(pr)
    })
    Promise.all(promesas)
    .then(resuelto => {
      resuelto.forEach(item => {
        all.push(item.data())
      })
      return resolve(all)
    })
    .catch(e => {
      console.error(e)
      reject()
    })
  })
}
